<template>
    <!-- Новий дизайн: сортування меню біля пошуку. Кнопка показує вибране, список — під нею;
         закривається вибором, Esc, Tab чи дотиком поза ним. Стрілки ↑↓ ходять пунктами -->
    <div class="bp-sort" ref="root">
        <button type="button" class="bp-rnd-btn bp-sort-btn" :class="{ 'is-on': value != 'popular' }" ref="btn"
                aria-haspopup="true" :aria-expanded="open ? 'true' : 'false'"
                :aria-label="'Сортування: ' + current.label" :title="'Сортування: ' + current.label"
                @click="toggle()" @keydown.down.prevent="show()">
            <span class="bp-rnd-btn__ic" v-html="icons.sort"></span><span class="bp-rnd-btn__t">{{ current.label }}</span>
        </button>
        <div v-if="open" class="bp-sort__menu" role="menu" aria-label="Сортування" ref="menu" :style="{ left: shift + 'px' }"
             @keydown.esc.prevent="close(true)" @keydown.down.prevent="move(1)" @keydown.up.prevent="move(-1)" @keydown.tab="close(false)">
            <button v-for="item in SORTS" :key="item.key" type="button" role="menuitemradio" class="bp-sort__item" ref="items"
                    :aria-checked="value == item.key ? 'true' : 'false'" @click="pick(item.key)">
                <span class="bp-sort__ic" v-html="icons[item.icon]"></span><span class="bp-sort__t">{{ item.label }}</span>
                <span class="bp-sort__check" v-if="value == item.key" v-html="icons.check"></span>
            </button>
        </div>
    </div>
</template>

<script>
import { ICONS } from '@/v2icons'
import { SORTS } from '@/menuSort'

export default {
    name: 'BpSortMenu',
    props: {
        // Ключ із SORTS (v-model)
        value: { type: String, default: 'popular' }
    },
    data() {
        return {
            icons: ICONS,
            SORTS,
            open: false,
            shift: 0
        }
    },
    computed: {
        current() {
            return SORTS.find(item => item.key == this.value) || SORTS[0];
        }
    },
    beforeDestroy() {
        document.removeEventListener('pointerdown', this.onOutside, true);
    },
    methods: {
        toggle() {
            if (this.open) this.close(false);
            else this.show();
        },
        // Відкриваємо з фокусом на вибраному пункті. Список — від лівого краю кнопки, але в межах екрана з відступом 8 px:
        // на телефоні 360–390 px кнопка стоїть посередині ряду, і список вилазив праворуч на 12 px
        show() {
            this.open = true;
            this.shift = 0;
            document.addEventListener('pointerdown', this.onOutside, true);
            this.$nextTick(() => {
                const left = this.$refs.btn.getBoundingClientRect().left;
                const width = this.$refs.menu.offsetWidth;
                const max = document.documentElement.clientWidth - 8 - width;
                this.shift = Math.round(Math.max(8, Math.min(left, max)) - left);
                const items = this.$refs.items || [];
                const item = items[Math.max(0, SORTS.findIndex(s => s.key == this.value))];
                if (item) item.focus();
            });
        },
        close(focusButton) {
            this.open = false;
            document.removeEventListener('pointerdown', this.onOutside, true);
            if (focusButton && this.$refs.btn) this.$refs.btn.focus();
        },
        onOutside(e) {
            if (!this.$refs.root.contains(e.target)) this.close(false);
        },
        move(step) {
            const items = this.$refs.items || [];
            const next = items[(items.indexOf(document.activeElement) + step + items.length) % items.length];
            if (next) next.focus();
        },
        pick(key) {
            this.$emit('input', key);
            this.close(true);
        }
    }
}
</script>
